import styled from '@emotion/styled';
import { Css, ITheme, Responsive, ResponsivePicture } from '../../../ui';

export const HighlightImage = styled(ResponsivePicture, {
	shouldForwardProp: (prop) => prop !== 'isFirst',
})<{ isFirst: boolean }, ITheme>`
	position: relative;
	display: inline-block;

	// IE11 fix
	display: block;

	img {
		border-radius: 16px;
		${({ isFirst }) => `
				border-top-${isFirst ? 'left' : 'right'}-radius: 0;
				border-bottom-${isFirst ? 'left' : 'right'}-radius: 0;
			`}

		@media (${Responsive.getMediaQueryForBreakpoint('desktopXL')}) {
			border-radius: 16px;
		}
	}

	&::after {
		content: '';
		position: absolute;
		bottom: ${Css.pxToRem(-24)};
		${({ isFirst }) =>
			isFirst ? `right: ${Css.pxToRem(-24)};` : `left: ${Css.pxToRem(-24)};`}
		width: 100%;
		height: 100%;
		border-radius: 16px;
		background-color: ${(props) => props.theme.color.primaryLight};
		z-index: -1;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: 360px;

		img {
			border-radius: 0;
		}

		&::after {
			right: 0;
			left: 0;
		}
	}
`;
